import { createSlice } from "@reduxjs/toolkit";
import { GetBranchList } from "../../async-actions/digitalmarketing/branchList";

const initialState = {
    branchList: []
}

const branchlistSlice = createSlice({
    name: "branchlist",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(GetBranchList.fulfilled.match, (state, action) => {
            state.branchList = action.payload.data;
        })
    },
});

export default branchlistSlice.reducer;
